import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import { googleMapLoad } from './actions.js';

import { GetDirectionsComponent } from '../../components/FindPollingStation/GetDirections';
import {
    ConfirmationInfoFullAddress,
    ConfirmationInfoTitle,
    ConfirmationInfoOtherDetails
} from '../../components/FindPollingStation/ConfirmationInfo';
import { ActionTypes } from '../../utils/enums';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

const IframeContainer = styled.div`
    width: 180px;
    height: 180px;
    position: relative;
    margin-right: 20px;

    @media (max-width: 30em) {
        width: 100%;
        height: 140px;
        margin-bottom: 12px;
        margin-right: 0;
    }

    iframe {
        width: 100%;
        height: 100%;
    }

    div {
        &:before {
            border: 3px solid rgba(0, 0, 0, 0.2);
            border-top-color: rgba(0, 0, 0, 0.5);
        }
    }
`;

const Iframe = styled.iframe`
    border: 0;
`;

const IframeComponent = props => (
    <IframeContainer>
        {!props.googleMapIsLoaded && <LoadingSpinner />}
        <Iframe
            src={`https://maps.google.com/maps?hl=en&q=${
                props.fullAddress
                }&ie=UTF8&t=&z=15&iwloc=B&iwloc=near&output=embed`}
            frameborder="0"
            scrolling="no"
            allowfullscreen="false"
            onLoad={props.googleMapLoad}
        />
    </IframeContainer>
);

IframeComponent.propTypes = {
    googleMapLoad: PropTypes.func.isRequired,
    googleMapIsLoaded: PropTypes.bool.isRequired,
    fullAddress: PropTypes.string.isRequired
};

const TitleComponent = props => <Title>{props.title}</Title>;

TitleComponent.propTypes = {
    title: PropTypes.string.isRequired
};

const FindPollingStationSuccess = props => (
    <TransitionContainerNoExit zIndex={15}>
        <ConfirmationCard
            thankYouText={props.otherDetails}
            titleComponent={<TitleComponent title={props.title} />}
            getDirectionsComponent={
                <GetDirectionsComponent fullAddress={props.fullAddress} />
            }
            iframeComponent={
                <IframeComponent
                    fullAddress={props.fullAddress}
                    googleMapLoad={props.googleMapLoad}
                    googleMapIsLoaded={props.googleMapIsLoaded}
                />
            }
            fullAddress={props.fullAddress}
            hideSubtitle={true}
            beforeAdvancing={() => {
                props.setExitingCardProps(
                    'findPollingStation',
                    props,
                    props.exitingAction
                );
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

FindPollingStationSuccess.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    otherDetails: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    fullAddress: PropTypes.string.isRequired,
    googleMapLoad: PropTypes.func.isRequired,
    googleMapIsLoaded: PropTypes.bool.isRequired,
    setExitingCardProps: PropTypes.func.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'findPollingStation',
            ['/findPollingStation/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const completeFindPollingStation =
            state.findPollingStation.completeFindPollingStation;

        return {
            exitingAction: state.widget.activeAction,
            title: ConfirmationInfoTitle(completeFindPollingStation),
            otherDetails: ConfirmationInfoOtherDetails(completeFindPollingStation),
            fullAddress: ConfirmationInfoFullAddress(completeFindPollingStation),
            googleMapIsLoaded: state.findPollingStation.googleMapIsLoaded
        };
    },
    { googleMapLoad, setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.FindPollingStation)
                return true;

            return next === prev;
        }
    }
)(FindPollingStationSuccess);
